var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportDeactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 3,
    fill: "white",
    stroke: "#D2DAEA",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3784 13.7838H23.4325L18.3784 8.72973V13.7838ZM11.946 7.35135H19.2973L24.8109 12.8649V23.8919C24.8109 24.3793 24.6172 24.8468 24.2726 25.1914C23.9279 25.5361 23.4604 25.7297 22.973 25.7297H11.946C11.4586 25.7297 10.9911 25.5361 10.6464 25.1914C10.3018 24.8468 10.1082 24.3793 10.1082 23.8919V9.18919C10.1082 8.16919 10.926 7.35135 11.946 7.35135ZM12.8649 23.8919H14.7027V18.3784H12.8649V23.8919ZM16.5406 23.8919H18.3784V16.5405H16.5406V23.8919ZM20.2163 23.8919H22.0541V20.2162H20.2163V23.8919Z",
    fill: "#BEC5D1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportDeactive);
export default __webpack_public_path__ + "static/media/report_deactive.835c689090db4279962bc1f21d57a394.svg";
export { ForwardRef as ReactComponent };